import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pendingCount: 0,
};

const suggestionSlice = createSlice({
    name: "suggestion",
    initialState,
    reducers: {
        getPendingSuggestionCount() {},
        setPendingSuggestionCount(state, action) {
            state.pendingCount = action.payload || 0;
        },
    },
});

export const { getPendingSuggestionCount, setPendingSuggestionCount } = suggestionSlice.actions;

export default suggestionSlice.reducer;
